export type CardBrand = "visa" | "mastercard" | "amex" | "unknown";

const CARD_BRAND_LABEL: Record<CardBrand, string> = {
    visa: "Visa",
    mastercard: "Mastercard",
    amex: "American Express",
    unknown: "desconocida",
};

/**
 * Detecta la marca de la tarjeta a partir de sus primeros digitos (BIN),
 * usando los rangos publicos estandar de cada red. Si no hay digitos
 * suficientes o no coincide con ningun rango conocido, devuelve "unknown"
 * (no bloqueante: no hay info suficiente para afirmar que este mal).
 */
export const detectCardBrand = (cardNumber: string | null | undefined): CardBrand => {
    const digits = (cardNumber ?? "").replace(/\D/g, "");
    if (digits.length < 2) return "unknown";

    if (/^4/.test(digits)) return "visa";
    if (/^3[47]/.test(digits)) return "amex";
    if (/^5[1-5]/.test(digits)) return "mastercard";

    if (digits.length >= 4) {
        const prefix4 = Number(digits.slice(0, 4));
        if (prefix4 >= 2221 && prefix4 <= 2720) return "mastercard";
    }

    return "unknown";
};

export const cardBrandLabel = (brand: CardBrand): string => CARD_BRAND_LABEL[brand];

/**
 * Compara la marca detectada por el numero contra la descripcion del tipo
 * de tarjeta elegido en el selector (catalogo en texto libre del backend,
 * ej. "Visa", "Mastercard", "American Express"). Si la marca detectada es
 * "unknown" no se considera error, porque no hay info suficiente.
 */
export const cardNumberMatchesSelectedBrand = (
    cardNumber: string | null | undefined,
    selectedDescripcion: string | null | undefined,
): boolean => {
    const brand = detectCardBrand(cardNumber);
    if (brand === "unknown") return true;

    const desc = (selectedDescripcion ?? "").toLowerCase();
    switch (brand) {
        case "visa":
            return desc.includes("visa");
        case "mastercard":
            return desc.includes("master");
        case "amex":
            return desc.includes("amex") || desc.includes("american express");
        default:
            return true;
    }
};
